import React, { useState } from 'react';
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate';
import { Field, Form } from "react-jsonschema-form-validation";
import { pathRoot } from '../AsbestosHistory';
import { Checkbox } from "../../../components/common/FormInputs";

export function Page2({ asbestosHistory }) {

	const schema = {
		type: 'object'
	};

	const optionsData = [{
		label: "Armed Forces",
		id: "armedForces",
		value: 0
	}, {
		label: "Secretarial or Admin",
		id: "secretarialOrAdmin",
		value: 1
	}, {
		label: "Joiner or Carpenter",
		id: "joinerOrCarpenter",
		value: 2
	}, {
		label: "Electrician",
		id: "electrician",
		value: 3
	}, {
		label: "Plumber",
		id: "plumber",
		value: 4
	}, {
		label: "Builder",
		id: "builder",
		value: 5
	}, {
		label: "Lagger",
		id: "lagger",
		value: 6
	}, {
		label: "Education/Teacher",
		id: "educationTeacher",
		value: 7
	}, {
		label: "Healthcare",
		id: "healthcare",
		value: 8
	}, {
		label: "Mechanic",
		id: "mechanic",
		value: 9
	}, {
		label: "Engineer",
		id: "engineer",
		value: 10
	}, {
		label: "Power Station Worker",
		id: "powerStationWorker",
		value: 11
	}, {
		label: "Other",
		id: "other",
		value: 12
	}];

	const [occupationHistory, setOccupationHistory] = useState(asbestosHistory.occupationHistory);

	const toggleOccupationHistory = (value) => {
		if (isChecked(value)) {
			setOccupationHistory(occupationHistory.filter(e => e !== value));
		} else {
			const temp = [...occupationHistory];
			temp.push(value);
			setOccupationHistory(temp);
		}
	};

	const isChecked = (value) => {
		return occupationHistory.some(e => e === value);
	};

	const optionsElements = optionsData.map(e => {
		return (
			<>
				<Field type="select"
					key={e.id}
					name="occupationHistory"
					id={e.id}
					className={"hidden"}
					checked={isChecked(e.value)}
					onClick={() => toggleOccupationHistory(e.value)} 
				/>
				<Checkbox 
					key={`label${e.id}`}
					htmlFor={e.id}
					label={e.label}
					checked={isChecked(e.value)}
				/>
			</>);
	});

	const updateUserSettings = () => {
		asbestosHistory.occupationHistory = [...occupationHistory];
	};

	const onNext = () => {
		if (occupationHistory.some(e => e === 0)) { }
		else {
			asbestosHistory.armedForcesType = null;
			asbestosHistory.lengthOfService = null;
		}

		updateUserSettings();
	};

	const nextTo = () => {
		const nextPage = isChecked(0) ? 3 : 4;
		return `${pathRoot}/${nextPage}`;
	};

	const headerDetails = {
		title: "Asbestos History",
		currentPage: 2,
		pageCount: 4
	};

	return (<>
		<SetupDataPageTemplate headerDetails={headerDetails} backTo={`${pathRoot}/1`} nextTo={nextTo()} onClickBack={updateUserSettings} onClickNext={onNext} hideNext={occupationHistory.length === 0}>
	
				<Form schema={schema}>
					<p className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						What is your occupation history?
					</p>
					<p className={"mb-6"}>(select all that apply)</p>

					<div>
						{optionsElements}
					</div>
				</Form>
			
		</SetupDataPageTemplate>
	</>);
}
